// src/api/consent.js
//
// API СОГЛАСИЙ НА ОБРАБОТКУ ПДн И КУКИ.
//
// 📌 ОБРАЗЕЦ ВЗЯТ ИЗ NORRAN (`backend/src/routes/consentRoutes.js`).
//    Три маршрута, потому что согласий три вида и нужна история:
//      GET    /consent/status  — что уже дано (для показа баннера)
//      POST   /consent         — зафиксировать согласие
//      DELETE /consent         — отозвать согласие
//
// 🔑 ПОЧЕМУ ВСЁ ЧЕРЕЗ СЕРВЕР, А НЕ localStorage:
//    По ч. 1 ст. 9 152-ФЗ оператор ОБЯЗАН ДОКАЗАТЬ наличие согласия.
//    Галочка в браузере не доказывает ничего: она исчезает с очисткой
//    хранилища и серверу не видна. Поэтому запись живёт в БД — с датой,
//    версией текста и IP.
//
// ⚠️ СОСТОЯНИЕ: бэкенд-часть В СТУДИИ ЕЩЁ НЕ СДЕЛАНА
//    (см. `ARCHITECTURE_TASKS.txt` п.11). Модуль написан заранее, чтобы
//    фронтенд был готов; до появления эндпоинтов вызовы будут падать, а
//    баннер — НЕ показываться (это безопасное поведение, разбор в
//    `CookieConsentBanner.jsx`).
import client from './client.js';

/**
 * Виды согласия — словарь, а не свободная строка.
 *
 * ⚠️ Согласие на рекламную рассылку — ОТДЕЛЬНОЕ (ст. 15 152-ФЗ требует
 *    своё). Поэтому три вида, а не один «общий»: смешав их, нельзя будет
 *    доказать, на что именно человек согласился.
 */
export const CONSENT_TYPES = {
  PERSONAL_DATA: 'personal_data',
  COOKIE: 'cookie',
  MARKETING: 'marketing',
};

export const consentAPI = {
  /**
   * Что уже согласовано.
   *
   * @param {string} [anonymousId] — идентификатор браузера. Нужен для
   *   НЕАВТОРИЗОВАННОГО посетителя: у него строки в `users` нет, и опознать
   *   его иначе нечем. ⚠️ Это подсказка серверу, а НЕ доказательство
   *   согласия — по нему нельзя войти.
   */
  getStatus: (anonymousId) =>
    client.get('/consent/status', {
      params: anonymousId ? { anonymous_id: anonymousId } : {},
    }),

  /**
   * Зафиксировать согласие.
   *
   * @param {object} data
   * @param {string} data.consent_type — из `CONSENT_TYPES`
   * @param {string} data.document_version — редакция текста («1.0»).
   *   Без неё после правки текста нельзя ответить, на что человек согласился.
   * @param {string} [data.anonymous_id]
   */
  accept: (data) => client.post('/consent', data),

  /**
   * Отозвать согласие.
   *
   * ⚠️ Отзыв — это `revoked_at` в БД, а НЕ удаление записи: удалив строку,
   *    мы потеряли бы доказательство, что согласие БЫЛО и действовало до
   *    момента отзыва.
   */
  revoke: (consentType, anonymousId) =>
    client.delete('/consent', {
      data: {
        consent_type: consentType,
        ...(anonymousId ? { anonymous_id: anonymousId } : {}),
      },
    }),
};
